<template>
  <a-checkbox-group style="width:500px" v-model:value="idList">
    <a-row>
      <a-col class="m-b-10" v-for='item in tagList' :key='item' :span="8">
        <a-checkbox :value="item.id">{{item.name}}</a-checkbox>
      </a-col>
    </a-row>
  </a-checkbox-group>
  <div class="m-t-20">
    <a v-if='!addTagType' v-has:wxFansTagAdd='()=>{addTagType = !addTagType}' href="javascript:;">新建标签</a>
    <div class="s_flex_ali " v-else>
      <a-input style="width:300px" v-model:value="tagName" :maxlength='15' placeholder="最多可输入15个字符" />
      <a-button class="m-l-15" type="link" @click="createTag">添加</a-button>
      <a-button type="link" @click='addTagType = !addTagType'>取消</a-button>
    </div>
  </div>
  <div class="s_flex_center m-t-40">
    <a-button class="width-100" type="primary" v-has:wxFansTagUserSet="onSumbit" :loading='iconLoading'>确定</a-button>
    <a-button class="m-l-25 width-100" type="primary" ghost @click="cancel('bnt')">取消</a-button>
  </div>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs,watchEffect } from 'vue';
import { message } from 'ant-design-vue';
import { iscode } from '@/utils/app';
import { setFansTag,createTags } from '@/api/public_wx';
export default {
  components: {},
  props: {
    tagList: {
      type: Array,
    },
    tagIds:{
      type:Array
    },
    checkedList:{
      type:Array
    },
    isBatch:{
      type:Number
    }
  },
  name: 'tag_list',
  setup(props,{emit}) {
    const state = reactive({
      value: [],
      addTagType: false,
      tagName: '',
      idList: [],
      iconLoading:false
    });
    const $router = inject('$router');
    const $Modal = inject('$Modal');

    //选择标签
    // const getOpenId = (item) => {
    //   state.idList.push(item.id)
    // };

    //为粉丝打标签
    const onSumbit = async () => {
      let result = state.idList
      state.iconLoading = true
      let res = await setFansTag({
        open_ids:Object.values(props.checkedList),
        tag_ids:result,
        //
        is_batch:props.isBatch
      }).then((res) => res.data);
      if (iscode(res, true)) {
        cancel('sub')
        // state.idList=[]
      }
      state.iconLoading = false
    };

     //新增粉丝标签
    const  createTag = async () => {
      let res = await createTags({ title: state.tagName }).then(
        (res) => res.data
      );
      if (iscode(res, true)) {
        emit('reload',true)
      }
    };

    //关闭弹窗
    const cancel = (type)=>{
      emit('close',type)
    }
    watchEffect(() => {
      if (props.tagIds) {
        state.idList = props.tagIds
      } else {
        state.idList = [];
      }
    });
    onMounted(() => {});
    return {
      ...toRefs(state),
      onSumbit,
      createTag,
      cancel
    };
  },
};
</script>